// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"3b8c96fd","77":"4f3da829","110":"769426fd","140":"38df84b6","144":"216d3295","243":"6ee54cdf","271":"a3cf57cc","422":"d780d36b","453":"c9161952","619":"944cd990","624":"63e2d667","784":"a805402d","826":"ca42b1bc","841":"5a359019"}[chunkId] + ".chunk.js";
};